import React from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import WorkflowTaskEditItemRevisionDatesModel from '../../../models/WorkflowTaskEditItemRevisionDatesModel';
import { Result } from '../../../types/Result';

interface IProps {
    formData: WorkflowTaskEditItemRevisionDatesModel
    onCellChange?: (value: any, rowIndex: number, dataProp?: string) => void
    serverErrors?: Result[]
}

const TaskEditItemRevisionDatesView: React.FC<IProps> = ({ formData, onCellChange, serverErrors }) => {
    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Revision', dataProp: 'revisionNumber', width: 400 },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date', editable: true },
        { title: 'End date', dataProp: 'endDate', dataType: 'date', editable: true },
    ];

    return (
        <div style={{ marginBottom: 20 }}>
            <DataTable key='dtWorkflowEditItemRevisionDates'
                name='dtWorkflowEditItemRevisionDates'
                colInfos={colInfos}
                tableData={formData.itemRevisions}
                serverErrors={serverErrors}
                onCellChange={onCellChange}
            />
        </div>
    );
}
export default TaskEditItemRevisionDatesView;